const ManageCardPreFix = "ManageCard";

export const MANAGE_CARD_TEST_IDS = {
    button: `${ManageCardPreFix}_actionBtn`,
    saveCardInfoMessage: `${ManageCardPreFix}_saveCardInfoMessage`,
    secureCardHalfCard: `${ManageCardPreFix}_secureCardHalfCard`,
    knowMore: `${ManageCardPreFix}_KnowMore`,
};
